export const getExpressCheckoutButtonVisibility = (
  value: boolean,
): 'always' | 'never' => {
  return value ? 'always' : 'never';
};
